// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  height: 100vh;
  display: flex;
  overflow: hidden;
  flex-direction: column;
}
:host .navigation-logo {
  background-color: white;
  padding: 10px;
  box-sizing: border-box;
  color: black;
  margin-right: 35px;
}
:host .navigation-logo img {
  width: 100%;
  height: 100%;
}
:host .brover-navigation-container {
  flex: 1;
  overflow: hidden;
}
:host .brover-navigation-container .brover-navigation {
  background-color: #ffffff;
  color: white;
  width: 80%;
  min-width: 140px;
  max-width: 440px;
  overflow: auto;
}
:host .brover-navigation-container .brover-navigation .navigation-content {
  padding: 0 0 0 20px;
  flex: 1;
}
:host .brover-navigation-container .brover-navigation .navigation-content .nav-item {
  position: relative;
  display: flex;
  font-size: 17px;
  margin-bottom: 10px;
  text-decoration: none;
  color: #222;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  padding: 15px 0 15px 40px;
}
:host .brover-navigation-container .brover-navigation .navigation-content .nav-item.active {
  background-color: #c59f81;
  color: white;
}
:host .brover-navigation-container .brover-content {
  height: calc(100vh - 100px);
  display: flex;
  min-width: 100%;
  overflow: hidden;
  background-color: white;
  border-top: 1px solid gainsboro;
  flex-direction: column;
}
:host .brover-navigation-container .brover-content .main-content {
  flex: 1;
  overflow: auto;
  background-color: #e8e8e8;
}

.brover-menu {
  height: 100px;
  display: flex;
  color: white;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  background-color: white;
  align-items: center;
  overflow: hidden;
}
.brover-menu .profile-wrapper {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 30px 0 10px;
  color: black;
  height: 100%;
  border-bottom: 1px solid rgba(210, 210, 210, 0.72);
}
.brover-menu .profile-wrapper .sep {
  height: 20%;
  width: 2px;
  background-color: #e2e2e2;
  margin-right: 15px;
}
.brover-menu .profile-wrapper .email-text {
  display: inline-block;
  color: #7a7976;
  font-weight: bold;
  font-size: 14.5px;
  text-transform: uppercase;
  padding: 0;
  position: relative;
  transition: color 0.15s;
  text-decoration: none;
  margin-right: 10px;
}
.brover-menu .profile-wrapper .profile-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.brover-menu .profile-wrapper .profile-container .profile-icon {
  margin-right: 10px;
  background-color: #d6d6d6;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.brover-menu .profile-wrapper .profile-container .profile-icon img {
  width: 50px;
}
@media (min-width: 1025px) {
  .brover-menu .profile-wrapper .profile-container .profile-icon .sidenav-toggle {
    display: none !important;
  }
}

.toggle {
  display: flex;
  flex: 1;
  justify-content: flex-end;
  color: black;
  margin-right: 20px;
}

.kek {
  width: 100%;
  display: flex;
  height: 160px;
  background-color: #f7972d;
  border-bottom: 1px solid rgba(100, 100, 100, 0.1);
  margin-bottom: 20px;
  box-sizing: border-box;
  padding: 20px 30px;
  align-items: flex-end;
  justify-content: space-between;
}
.kek span {
  font-weight: bold;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contact {
  padding: 35px;
  color: rgba(11, 14, 20, 0.71);
}
.contact a {
  text-decoration: none;
  outline: none;
  color: rgba(11, 14, 20, 0.71);
}
.contact .contact-title {
  font-weight: bold;
  text-transform: none;
  color: #222;
  font-size: 18px;
  margin: 0 0 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/brover-default-component/root/root.component.sass"],"names":[],"mappings":"AAAC;EACC,aAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AACF;AACE;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;AACN;AACE;EACE,OAAA;EACA,gBAAA;AACJ;AACI;EACE,yBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AACN;AACM;EACE,mBAAA;EACA,OAAA;AACR;AACQ;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;AACV;AACU;EACE,yBAAA;EACA,YAAA;AACZ;AACI;EACE,2BAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,+BAAA;EACA,sBAAA;AACN;AACM;EACE,OAAA;EACA,cAAA;EACA,yBAAA;AACR;;AACA;EACE,aAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAEF;AAAE;EACE,OAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,kDAAA;AAEJ;AAAI;EACE,WAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;AAEN;AAAI;EACE,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;AAEN;AAAI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAEN;AAAM;EACE,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAER;AAAQ;EACE,WAAA;AAEV;AACQ;EACE;IACE,wBAAA;EACV;AACF;;AADA;EACE,aAAA;EACA,OAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AAIF;;AAFA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,yBAAA;EACA,iDAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,8BAAA;AAKF;AAHE;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAKJ;;AAHA;EACE,aAAA;EACA,6BAAA;AAMF;AAJE;EACE,qBAAA;EACA,aAAA;EACA,6BAAA;AAMJ;AAJE;EACE,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAMJ","sourcesContent":["\\:host\n  height: 100vh\n  display: flex\n  overflow: hidden\n  flex-direction: column\n\n  .navigation-logo\n    background-color: white\n    padding: 10px\n    box-sizing: border-box\n    color: black\n    margin-right: 35px\n\n    img\n      width: 100%\n      height: 100%\n\n  .brover-navigation-container\n    flex: 1\n    overflow: hidden\n\n    .brover-navigation\n      background-color: #ffffff\n      color: white\n      width: 80%\n      min-width: 140px\n      max-width: 440px\n      overflow: auto\n\n      .navigation-content\n        padding: 0 0 0 20px\n        flex: 1\n\n        .nav-item\n          position: relative\n          display: flex\n          font-size: 17px\n          margin-bottom: 10px\n          text-decoration: none\n          color: #222\n          align-items: center\n          box-sizing: border-box\n          cursor: pointer\n          user-select: none\n          padding: 15px 0 15px 40px\n\n          &.active\n            background-color: #c59f81\n            color: white\n\n    .brover-content\n      height: calc(100vh - 100px)\n      display: flex\n      min-width: 100%\n      overflow: hidden\n      background-color: white\n      border-top: 1px solid gainsboro\n      flex-direction: column\n\n      .main-content\n        flex: 1\n        overflow: auto\n        background-color: #e8e8e8\n\n.brover-menu\n  height: 100px\n  display: flex\n  color: white\n  max-width: 1200px\n  width: 100%\n  margin: 0 auto\n  background-color: white\n  align-items: center\n  overflow: hidden\n\n  .profile-wrapper\n    flex: 1\n    display: flex\n    justify-content: flex-end\n    align-items: center\n    padding: 0 30px 0 10px\n    color: black\n    height: 100%\n    border-bottom: 1px solid rgba(210, 210, 210, 0.72)\n\n    .sep\n      height: 20%\n      width: 2px\n      background-color: #e2e2e2\n      margin-right: 15px\n\n    .email-text\n      display: inline-block\n      color: #7a7976\n      font-weight: bold\n      font-size: 14.5px\n      text-transform: uppercase\n      padding: 0\n      position: relative\n      transition: color .15s\n      text-decoration: none\n      margin-right: 10px\n\n    .profile-container\n      display: flex\n      align-items: center\n      cursor: pointer\n      user-select: none\n\n      .profile-icon\n        margin-right: 10px\n        background-color: #d6d6d6\n        width: 50px\n        height: 50px\n        border-radius: 50%\n\n        img\n          width: 50px\n\n\n        @media (min-width: 1025px)\n          .sidenav-toggle\n            display: none !important\n.toggle\n  display: flex\n  flex: 1\n  justify-content: flex-end\n  color: black\n  margin-right: 20px\n\n.kek\n  width: 100%\n  display: flex\n  height: 160px\n  background-color: #f7972d\n  border-bottom: 1px solid rgba(100,100,100,.1)\n  margin-bottom: 20px\n  box-sizing: border-box\n  padding: 20px 30px\n  align-items: flex-end\n  justify-content: space-between\n\n  span\n    font-weight: bold\n    height: 40px\n    display: flex\n    justify-content: center\n    align-items: center\n\n.contact\n  padding: 35px\n  color: rgba(11,14,20,.71)\n\n  a\n    text-decoration: none\n    outline: none\n    color: rgba(11,14,20,.71)\n\n  .contact-title\n    font-weight: bold\n    text-transform: none\n    color: #222\n    font-size: 18px\n    margin: 0 0 30px\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
